<table class="table table-responsive-lg table-bordered mt-2" *ngIf="item">
  <tbody>
  <tr *ngFor="let key of keys">
    <td>
      {{ key }}
    </td>
    <td>
      {{ item[key] }}
    </td>
  </tr>
  </tbody>
</table>
<br/>



// WEBPACK FOOTER //
// ./src/app/page/logitem/logitem.component.html